import React from "react";
import styles from "./PeopleUI.module.css";
import Avatar from "../../../components/common/Avatar";
import RowActionsMenu from "../../../components/common/RowActionsMenu";
import EmptyContact from "./EmptyContact";
import { getRoleVariant, getRoleLabel } from "./roleVariant";

const VARIANT_ACCENT = {
  owner: styles.roleOwner,
  employee: styles.roleEmployee,
  contractor: styles.roleContractor,
  invited: styles.roleInvited,
  role: styles.roleRole,
};

const VARIANT_PILL = {
  owner: styles.rolePillOwner,
  employee: styles.rolePillEmployee,
  contractor: styles.rolePillContractor,
  invited: styles.rolePillInvited,
  role: styles.rolePillRole,
};

export default function PersonRow({ employee, onClick, onAddContactInfo, actions }) {
  const variant = getRoleVariant(employee);
  const accentClass = VARIANT_ACCENT[variant] || styles.roleNeutral;
  const pillClass = VARIANT_PILL[variant] || styles.rolePillEmployee;
  const isContractor = variant === "contractor";

  const email = employee.email || "";
  const phone = employee.phone_number || employee.phone || "";
  const hasAnyContact = !!(email || phone);

  return (
    <div
      className={`${styles.listRow} ${accentClass}`}
      onClick={onClick}
      role="row"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          onClick?.();
        }
      }}
    >
      <Avatar
        name={employee.name}
        imageUrl={employee.avatar_url}
        size="sm"
        variant={isContractor ? "contractor" : "default"}
      />
      <span className={styles.listCellName}>{employee.name}</span>
      <span>
        <span className={`${styles.rolePill} ${pillClass}`}>
          {getRoleLabel(employee, variant)}
        </span>
      </span>
      <span className={`${styles.listCellMeta} ${styles.listColEmail}`}>
        {email || (
          !hasAnyContact ? (
            <EmptyContact
              employee={employee}
              onAddContactInfo={onAddContactInfo}
              variant={isContractor ? "link" : "muted"}
            />
          ) : ""
        )}
      </span>
      <span className={`${styles.listCellMeta} ${styles.listColPhone}`}>
        {phone}
      </span>
      <span className={styles.listCellActions}>
        {actions && actions.length > 0 && <RowActionsMenu actions={actions} />}
      </span>
    </div>
  );
}

export function PersonListHeader() {
  return (
    <div className={styles.listHeaderRow} role="row">
      <span aria-hidden="true" />
      <span>Name</span>
      <span>Role</span>
      <span className={styles.listColEmail}>Email</span>
      <span className={styles.listColPhone}>Phone</span>
      <span aria-hidden="true" />
    </div>
  );
}
